import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class BranchApi extends WebApi {
    async createRoom(site) {
        const { data } = await axios.post(`${this.urlPrefix}/sites`, { site });
        return data;
    }
    async updateRoom(site, id) {
        const { data } = await axios.put(`${this.urlPrefix}/sites/${id}`, { site });
        return data;
    }
    async getBranchKpi(branch_id) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/components/kpis`, { branch_id }));
        return data;
    }
    async getBranchKpiData(params) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/kpis_branch_aggregators`, params));
        return data;
    }
    async getBranchKpiAppointmentAdvisorByCategory(category_id, branch_id, from, to) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/kpis_aggregators/appointment_advisors_by_category`, { category_id, branch_id, from, to }));
        return data.advisors_counts;
    }
}
const branchApi = new BranchApi();
export { branchApi as BranchApi, };
